module.exports = __webpack_public_path__ + "static/media/icon-warning.eddb7e31.svg";